"use client";

import {
  isChatSuppressedByMonarch,
  suppressNuanceChat,
} from "@/helpers/nuanceChat";
import {
  cohesion,
  type MonarchEvaluationsResult,
} from "@redventures/cohesion-utils-react";
import { useEffect } from "react";

export default function NuanceChatGate() {
  useEffect(() => {
    // monarch:done fires before cohesion("ready"), which is when
    // AdobeDataLayer sends the page view that triggers Comcast's Nuance rule.
    cohesion("monarch:done", (err: unknown, evaluation: unknown) => {
      if (err) {
        return;
      }

      if (
        isChatSuppressedByMonarch(evaluation as MonarchEvaluationsResult | null)
      ) {
        suppressNuanceChat();
      }
    });
  }, []);

  return null;
}
